<template>
  <b-container fluid class="m-0 p-0">
    <b-row class="border-bottom border-info pb-4">
      <b-col cols="3">
        <div
          class="m-0 mr-2 d-none d-sm-flex flex-column justify-content-center align-items-center"
          style="flex: 0 0 100px; min-width: 0"
        >
          <b-icon
            variant="secondary"
            :icon="cycleIcons[therapy.tipo]"
            font-scale="3"
          ></b-icon>
          <span class="text-center text-capitalize text-secondary pt-2">{{
            therapy.tipo
          }}</span>
        </div></b-col
      >
      <b-col>
        <b-row cols="1">
          <b-col>
            <div class="my-2 text-secondary text-uppercase">
              <h4 class="">
                {{ therapy.product_name }}
              </h4>
            </div>
          </b-col>
          <b-col>
            <div class="my-2 text-uppercase">
              <h6 v-if="therapy.pathology" class="">
                {{ therapy.pathology.name }} - {{ $t("RecapTherapy.pathology") }}
                {{ therapy.pathology.tipo }}
              </h6>
              <h6 v-else class="">{{ $t("RecapTherapy.noPathology") }}</h6>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="3"></b-col>
    </b-row>

    <b-row cols="2" class="pt-4" align-v="stretch">
      <b-col>
        <h5 class="text-secondary text-left pb-1">{{ $t("RecapTherapy.dosage") }}</h5>
        <div class="p-3">
          <h6 class="text-uppercase">
            {{ posNum }}
            {{
              posNum > 1
                ? therapy.posology_type
                : typesMap[therapy.posology_type]
            }}
            {{ $t("RecapTherapy.of") }} {{ therapy.product_name }} {{ therapy.posologia.tipo }}
            <span v-if="therapy.posologia.frequenza">
              {{ therapy.posology_every_num }}
              {{ therapy.posologia.frequenza }}
            </span>
            {{ $t("RecapTherapy.byRoute") }}
            <span>{{ therapy.posology_via }}. </span>
            <br />
            <span v-if="assunzioni">{{ $t("RecapTherapy.toTake") }}  {{ assunzioni }}.</span>
          </h6>
        </div>
      </b-col>
      <b-col>
        <h5 class="text-secondary text-left pb-1">{{ $t("RecapTherapy.duration") }}</h5>
        <div class="p-3 text-uppercase">
          <!-- Terapia di tipo occasionale -->
          <h6 v-if="therapy.type === 2" class="">
            {{ $t("RecapTherapy.from") }} {{ formatData(therapy.start_at) }} {{ $t("RecapTherapy.until") }}
            {{ formatData(therapy.end_at) }} .
          </h6>
          <!-- Terapia di tipo periodica -->
          <h6 v-else-if="therapy.type === 1" class="">
            {{ $t("RecapTherapy.followEvery") }} {{ therapy.every_num }}
            {{
              therapy.every_num > 1
                ? forEveryUmsPlur[therapy.every_um]
                : forEveryUmsSing[therapy.every_um]
            }}
            {{ $t("RecapTherapy.for") }}
            {{ therapy.for_num }}
            {{
              therapy.for_num > 1
                ? forEveryUmsPlur[therapy.for_um]
                : forEveryUmsSing[therapy.for_um]
            }}
            {{ $t("RecapTherapy.startingFrom") }} {{ formatData(therapy.start_at) }}.
          </h6>
          <!-- Terapia di tipo cronica -->
          <h6 v-else class="">{{ $t("RecapTherapy.undefined") }}</h6>
        </div>
      </b-col>
    </b-row>

    <b-row cols="2" class="pt-4 mb-5" align-v="stretch">
      <b-col>
        <h5 class="text-secondary text-left pb-1">{{ $t("RecapTherapy.notes") }}</h5>
        <div class="bg-white general_border shadow_2 p-3">
          <p class="my-4 pb-2">
            {{ therapy.details ? therapy.details : $t("RecapTherapy.noNotes") }}
          </p>
        </div>
      </b-col>
      <b-col>
        <h5 class="text-secondary text-left pb-1">{{ $t("RecapTherapy.details") }}</h5>
        <div class="p-3 text-uppercase">
           <h6>{{ $t("RecapTherapy.prescriber") }}: {{ therapy.prescrittore || $t("RecapTherapy.notIndicated") }}</h6>
          <h6>{{ $t("RecapTherapy.source") }}: {{ therapy.fonte_informativa || $t("RecapTherapy.notIndicated") }}</h6>
          <h6>{{ $t("RecapTherapy.sideEffects") }}: {{ therapy.effetti_collaterali || $t("RecapTherapy.notIndicated") }}</h6>
          <h6>{{ $t("RecapTherapy.allergicReactions") }}: {{ therapy.reazione_allergica || $t("RecapTherapy.notIndicated") }}</h6>
          <h6>{{ $t("RecapTherapy.interactions") }}: {{ therapy.interazioni || $t("RecapTherapy.notIndicated") }}</h6>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import * as moment from "moment/moment";
export default {
  name: "RecapTherapy",
  props: ["therapy"],
  data() {
    return {
      typesMap: {
        Compresse: this.$t("RecapTherapy.unit.compressa"),
        Capsule: this.$t("RecapTherapy.unit.capsula"),
        Gocce: this.$t("RecapTherapy.unit.goccia"),
        Inalazioni: this.$t("RecapTherapy.unit.inalazione"),
        Buste: this.$t("RecapTherapy.unit.busta"),
        Supposte: this.$t("RecapTherapy.unit.supposta"),
        Scatole: this.$t("RecapTherapy.unit.scatola"),
        Cerotti: this.$t("RecapTherapy.unit.cerotto"),
        Fiale: this.$t("RecapTherapy.unit.fiala"),
        Fleboclisi: this.$t("RecapTherapy.unit.fleboclisi"),
        Ovuli: this.$t("RecapTherapy.unit.ovulo"),
        Sacche: this.$t("RecapTherapy.unit.sacca"),
        Flaconi: this.$t("RecapTherapy.unit.flacone"),
        Confezioni: this.$t("RecapTherapy.unit.confezione"),
        Kilogrammi: this.$t("RecapTherapy.unit.kilogrammo"),
        Kit: this.$t("RecapTherapy.unit.kit"),
        Millilitri: this.$t("RecapTherapy.unit.millilitro"),
        Milligrammi: this.$t("RecapTherapy.unit.milligrammo"),
        Applicazioni: this.$t("RecapTherapy.unit.applicazione"),
        UI: this.$t("RecapTherapy.unit.UI"),
      },
      forEveryUmsSing: {
        0: this.$t("RecapTherapy.unitsSing.mese"),
        1: this.$t("RecapTherapy.unitsSing.settimana"),
        2: this.$t("RecapTherapy.unitsSing.giorno"),
      },
      forEveryUmsPlur: {
        0: this.$t("RecapTherapy.unitsPlur.mesi"),
        1: this.$t("RecapTherapy.unitsPlur.settimane"),
        2: this.$t("RecapTherapy.unitsPlur.giorni"),
      },
      cycleIcons: {
        periodica: "calendar",
        cronica: "watch",
        occasionale: "lightning",
      },
    };
  },
  computed: {
    posNum: function () {
      const num = parseFloat(this.therapy.posology_num);
      return num % 1 === 0 ? parseInt(num, 10) : num;
    },
    assunzioni: function () {
      const assunzioniKeys = [
        "mattina",
        "meta_mattina",
        "pranzo",
        "pomeriggio",
        "sera",
        "notte",
      ];
      let assunzioniString = assunzioniKeys.reduce((acc, key) => {
        if (this.therapy[key]) {
          acc += key + ", ";
        }
        return acc;
      }, "");

      if (assunzioniString === ", ") return null;

      assunzioniString = assunzioniString.replace(
        "meta_mattina",
        "metà mattina"
      );

      return assunzioniString.slice(0, -2) || null;
    },
  },
  methods: {
    formatData(data) {
      return moment(data).format("dddd DD MMMM YYYY");
    },
    formatDataShort(data) {
      return moment(data).format("DD/MM/YYYY");
    },
  },
  created() {
    //
  },
};
</script>
